import { render, staticRenderFns } from "./CheckboxFilter.vue?vue&type=template&id=38a1372e"
import script from "./CheckboxFilter.vue?vue&type=script&lang=js"
export * from "./CheckboxFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports